import { gsapSingleton } from '../gsap.js';

// Inizializzazione immediata dello smooth scroll per anchor link
const gsap = gsapSingleton();

// Gestisce tutti i link che puntano ad anchor interni
document.addEventListener('DOMContentLoaded', () => {
  
  // Handler per i click sui link anchor
  const handleAnchorClick = (e) => {
    const link = e.target.closest('a[href*="#"]');
    if (!link) return;
    
    const href = link.getAttribute('href');
    
    // Ignora link vuoti o solo "#"
    if (!href || href === '#') return;
    
    // Estrai l'hash dal link
    let targetId = '';
    
    // Se il link inizia con # è un anchor puro
    if (href.startsWith('#')) {
      targetId = href;
    } else {
      // Altrimenti verifica se il link punta alla stessa pagina
      const linkUrl = new URL(href, window.location.origin);
      const currentPath = window.location.pathname;
      
      // Se il path è diverso, lascia che il browser gestisca normalmente il link
      if (linkUrl.pathname !== currentPath) return;
      
      // Estrai l'hash
      targetId = linkUrl.hash;
      
      // Se non c'è hash, lascia che il browser gestisca normalmente
      if (!targetId) return;
    }
    
    const targetElement = document.querySelector(targetId);
    
    if (targetElement) {
      e.preventDefault();
      
      // Scroll smooth verso il target con offset per header fissi
      gsap.to(window, {
        duration: 1,
        scrollTo: {
          y: targetElement,
          offsetY: 10 // offset per header fissi, regolabile
        },
        ease: 'power2.inOut'
      });
      
      // Aggiorna l'URL senza ricaricare la pagina
      if (history.pushState) {
        history.pushState(null, null, targetId);
      }
    }
  };
  
  // Aggiungi event listener al document per catturare tutti i click
  document.addEventListener('click', handleAnchorClick);
  
  // Gestisce l'hash nell'URL al caricamento della pagina
  if (window.location.hash) {
    const targetElement = document.querySelector(window.location.hash);
    
    if (targetElement) {
      // Delay per permettere al DOM di caricarsi completamente
      setTimeout(() => {
        gsap.to(window, {
          duration: 1,
          scrollTo: {
            y: targetElement,
            offsetY: 100
          },
          ease: 'power2.inOut'
        });
      }, 100);
    }
  }
});

